import {
  createFileRoute,
  notFound,
  stripSearchParams,
} from '@tanstack/react-router';
import { z } from 'zod';
import { ISSUE_SEVERITY_VALUES } from '@/lib/agentIssues/issueSeverity';
import { ISSUE_STATUS_VALUES } from '@/lib/agentIssues/issueStatus';
import { REPORT_ORIGIN_VALUES } from '@/lib/interpretiveReports/reportOrigin';
import AgentIssues from '@/pages/agentIssues/AgentIssues';
import { MANAGE_PLATFORM_AGENT_ISSUE_REPORTS } from '@/utils/permissions';

const searchDefaults = {
  status: 'open' as const,
  page: 0,
  rates: 'chart' as const,
  origin: 'user' as const,
};

export const searchSchema = z.object({
  status: z
    .enum([...ISSUE_STATUS_VALUES, 'all'])
    .default(searchDefaults.status)
    .catch(searchDefaults.status),
  severity: z.enum(ISSUE_SEVERITY_VALUES).optional().catch(undefined),
  agentName: z.string().optional().catch(undefined),
  page: z
    .number()
    .int()
    .min(0)
    .default(searchDefaults.page)
    .catch(searchDefaults.page),
  rates: z
    .enum(['chart', 'table'])
    .default(searchDefaults.rates)
    .catch(searchDefaults.rates),
  origin: z
    .enum([...REPORT_ORIGIN_VALUES, 'all'])
    .default(searchDefaults.origin)
    .catch(searchDefaults.origin),
  issue: z.string().optional().catch(undefined),
});

export type AgentIssuesSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/_authenticated/_navbar/agent-issues')({
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(searchDefaults)],
  },
  beforeLoad: ({ context }) => {
    if (!context.auth.hasPermission(MANAGE_PLATFORM_AGENT_ISSUE_REPORTS)) {
      throw notFound();
    }
  },
  component: AgentIssues,
});
